import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    createDepartmentsModal: false,
    departmentListData: [],
    departmentsListPaginationData: {},
}

export const departments = createSlice({
    name: 'departments',
    initialState,
    reducers: {

        // C R E A T E
        createDepartmentsLoad: (state) => {
            state.loading = true
        },
        createDepartmentsSuccess: (state, action) => {
            state.loading = false
            state.createDepartmentsModal = false
        },
        createDepartmentsFail: (state) => {
            state.loading = false
        },

        // L I S T
        departmentsListLoad: (state) => {
            state.loading = true
        },
        departmentsListSuccess: (state, action) => {
            state.loading = false
            state.departmentListData = action?.payload?.data?.list
            state.departmentsListPaginationData = action?.payload?.data?.pagination
        },
        departmentsListFail: (state) => {
            state.loading = false
        },

        // D E L E T E
        departmentsDeleteLoad: (state) => {
            state.loading = true
        },
        departmentsDeleteSuccess: (state, action) => {
            state.loading = false
        },
        departmentsDeleteFail: (state) => {
            state.loading = false
        },

    }
});

export const {

    // C R E A T E
    createDepartmentsLoad,
    createDepartmentsSuccess,
    createDepartmentsFail,

    // L I S T
    departmentsListLoad,
    departmentsListSuccess,
    departmentsListFail,

    // D E L E T E
    departmentsDeleteLoad,
    departmentsDeleteSuccess,
    departmentsDeleteFail,

} = departments.actions;
export default departments.reducer;